<!--头部导航-->
<template>
  <div class="container" style="background-color: #fff; min-width: 1200px">
    <!-- <div class="logo">
      <img src="@/assets/images/logo.svg" alt />
    </div> -->
    <div class="module">
      <nav class="nav" ref="mainHeader">
        <span
          class="nav-item"
          :class="{ navActive: topActive == ind }"
          @click="topTab(ind, item)"
          v-for="(item, ind) in headItem"
          :key="ind"
          style="display:none;"
        >
          {{ item.tittle }}</span
        >

        <span
          @click="handleLink(val)"
          class="nav-item"
          v-for="val in popList"
          :key="val.id"
          style="width: 100px;position: relative;"
        >
          <img
            style="max-width: 100px;
            height: 30px;top: 31%;
            position: absolute;"
            :src="val.pcImgUrl"
            alt=""
          />
        </span>
        <!-- <i class="nav-underline" :style="navLineStyle"></i> -->
        <div class="white-bar" v-if="access" @click="handleShowWhiteBar">
          <img
            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/white-bar-entrance.png"
            style="width: 90px; height: 34px;"
            alt=""
          />
        </div>
      </nav>
    </div>
    <div class="rightContent">
      <img
        src="../assets/thdImg/home/icon_time.svg"
        alt
        style="vertical-align: middle;margin-right: 5px;"
      />
      <div style="display: flex;align-items: center;margin-right: 25px;">
        到期时间：{{ daysSoft }}
        <div class="authorization pointer" @click="AppAuth()">续费</div>
      </div>
      <!-- 店铺相关 -->
      <div class="head">
        <img
          src="../assets/thdImg/home/top_photo.svg"
          alt
          style="vertical-align: middle"
        />
        <div class="head_showInfo">
          <span class="head-name">
            <span
              @click="toShop"
              class="head-name-tit"
              style="display: inline-block;vertical-align: middle;padding: 0 4px;"
              >{{ this.$store.getters.loginUserInfo.sellerNick }}</span
            >
          </span>
          <i
            style="color: #000; position: relative; vertical-align: middle"
            class="el-icon-arrow-down"
          ></i>

          <!-- 弹出页面 -->
          <div class="hoverElement">
            <span class="hoverElement_xito">系统</span>
            <div class="hoverElement_setting pointer" @click="toUserInform">
              系统设置
            </div>
            <div
              class="hoverElement_setting pointer"
              style="padding-top: 0;"
              @click="log_out"
            >
              退出
            </div>
          </div>
        </div>
      </div>

      <div class="jiuban_button">店铺礼包版</div>
      <!-- <el-button style="margin-right: 25px" class="jiuban_button" @click="handlePlatform">切换平台</el-button> -->
    </div>

    <el-dialog
      title="公告内容"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="isPopVisiv"
      width="800px"
      :class="{ dialongTransition12: popItem.type == 0 }"
    >
      <div
        style="display: flex;justify-content: center;"
        v-if="popItem.type == 0"
      >
        <div style="position: relative;">
          <img
            @click="handleUrl"
            class="pointer"
            :src="popItem.pcPic"
            alt
            style="max-width:100%;margin: 0 auto;margin-top: 38px;"
          />
          <img
            class="pointer"
            style="position: absolute;"
            @click="isPopVisiv = false"
            src="@/assets/images/btn_关闭.png"
            alt=""
            width="29"
            height="29"
          />
        </div>
      </div>
      <template v-else>
        <div
          style="height: 500px;overflow-y: auto;padding-bottom: 20px;"
          v-html="popItem.richText"
        ></div>
      </template>
    </el-dialog>
    <div v-if="access" id="whiteBar"></div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { loginController } from "@/api/activityController";
import {
  getSellerInfo,
  getShopInfo,
  switchShop,
  returnOldSystem,
  // getMenuList,
  homeController,
  newAndOldShopIsPopUp,
  getMAToken,
  getOnceToken
} from "@/api/sellerController";

import { getMenuList } from "@/api/integralCenter/prizeCenter";

import { logout } from "@/api/login";
import axios from "axios";
import { async } from "q";

// import { cutHostToSonShop } from "@/api/login";
export default {
  name: "page-header",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },
  watch: {
    paths(newVal, oldVal) {
      // console.log("this.paths:", this.paths);
      if (this.paths && this.paths.length > 0) {
        let ind = this.paths[0].index;
        this.topActive = ind;
        // console.log(this.topActive);
        if (this.topActive == 5 && this.$route.query.venderId) {
          this.loginEvent();
        }
        // if (this.once === false) {
        //只需要刷新的时候调用一次
        this.bus.$emit("topActive", { index: ind, item: this.headItem[ind] });
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });

        // this.once = true;
        // }
        // this.$forceUpdate();
      }
    },
  },
  data() {
    return {
      appKey: "22AF00009B3D46B8DECBC457090B3560",
      componentId: "B8CABEC9CBBD5815C4C7BB89D7D45461",
      access: false,
      frontComponentUrl:"",
      reqId: "",
      isPopVisiv: false,
      popItem: {},
      popList: [],
      flag: false,
      topActive: 0,
      once: false,
      //实时信息数据
      softwarename: "",
      theme: "",
      switchList: [],
      softwareInfo: {
        versionName: "POP版",
      },
      accountSwitches: true,
      activeNavStyle: { left: 0, width: 0 },
      currentNavStyle: null,
      screenWidth: document.body && document.body.clientWidth, // 屏幕尺寸
      venId: null, //商家编号
      pathList: [],
      permissionPath:
        JSON.parse(localStorage.getItem("permissionPath_jhk")) || [],
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      switchListStore: "switchList",
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 订购类型
    subscribeType() {
      return this.$store.getters.loginUserInfo.subscribeType;
    },
    headItem() {
      return this.$store.state.route;
    },
    navLineStyle() {
      let style = this.currentNavStyle || this.activeNavStyle;
      return {
        width: `${style.width}px`,
        left: `${style.left}px`,
      };
    },
    picImg() {
      var defaultImg = require("@/assets/images/home/header.png");

      var img = defaultImg;
      if (
        this.$store.getters.loginUserInfo &&
        this.$store.getters.loginUserInfo.picPath
      ) {
        img = this.$store.getters.loginUserInfo.picPath;
      }
      return img;
    },
    invalidateDate() {
      var invalidateDate = this.$store.getters.loginUserInfo.invalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
    },
    daysSoft() {
      var str = "--";
      var invalidateDate = this.invalidateDate;
      // if (invalidateDate) {
      //   str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      // }
      return invalidateDate;
    },
  },
  mounted() {
    this.getFirstWhiteBarPop()
    let redict = sessionStorage.getItem("token");
    //  if(redict){
    this.bus.$on("topHeader", (obj) => {
      this.topTab(obj.index, obj.item);
    });
    if (
      location.pathname !== "/login" &&
      location.pathname !== "/" &&
      location.pathname !== "/login" &&
      location.pathname !== "/redirection"
    ) {
      this.getBindList();
      // 获取菜单
      this.getMenuData();
      // 顶部栏图
      this.popups();
    }

    // this.topTab();
    const that = this;
    window.onresize = () => {
      return (() => {
        // console.log('window.onresize:')
        window.screenWidth = document.body && document.body.clientWidth;
        that.screenWidth = window.screenWidth + 17; // 17 估计是滚动条的距离
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      })();
    };
    //  }
  },

  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
      editPointUserInfo: "POINTUSERINFO",
      getSwitchList: "getSwitchList",
      saveShopInfo: "SHOPINFO",
    }),
    handleShowWhiteBar() {
      if(this.access) {
        this.getWhiteBarPop()
      }
    },
    // 调用白条弹窗
    getJdMicroAppOpen() {
      if(!window.jdMicroAppOpenInstance) {
        window.jdMicroAppOpenInstance = window.jdMicroAppOpen.create();
      }
      // 先调下clear,确保组件未渲染
      jdMicroAppOpenInstance.clear()
      // 打开组件
      jdMicroAppOpenInstance.open({
        appKey: this.appKey,
        target: "#whiteBar",
        componentId: this.componentId,
        getOnceToken: async() => {
          const res = await getMAToken({componentId: this.componentId})
          const res1 = await getOnceToken({maTokee: res.data.token})
          return res1.data.token
        },
        customParams: {
          sourceType: 'ISVJHK',
          reqId: this.reqId
        }
      });
    },
    getWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
          this.reqId = res.data.reqId
          this.frontComponentUrl = res.data.frontComponentUrl
          if(this.access) {
            this.getJdMicroAppOpen()
          }
        }
      })
    },
    getFirstWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
        }
      })
    },
    handleUrl() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    handleLink(item) {
      if (item.pathType == 1) {
        window.open(item.pcPathUrl, "_blank");
      } else if (item.pathType == 2) {
        if (item.isNoGoingShow == 1 && item.popup.activityStatus == 2) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
        if (item.isNoGoingShow == 0) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
      }
    },
    popups() {
      homeController().then((res) => {
        this.popList = res.data;
        // 排序
        this.popList.sort((a, b) => {
          return a.position - b.position;
        });
        // console.log(res, 11111111111);
      });
    },
    AppAuth() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1415006?rdct=true",
        "_blank"
      );
    },
    //忠诚度管理登录
    getMenuData() {
      getMenuList().then(async (res) => {
        // 当顶部导航有两个或者以上的时    用var routerList = res.data;
        let arr = [
          {
            children: [...res.data],
            // children: arr1,
            title: "互动营销",
            menuType: "C",
            path: "/integralCenter",
          },
        ];
        var routerList = arr;
        // var routerList = res.data;
        var routerStr = JSON.stringify(routerList);
        routerStr = routerStr.replace(/title/g, "tittle");
        routerList = JSON.parse(routerStr);
        // console.log(routerList);
        this.$store.state.route = routerList;
        await this.routeLocal(routerList, "");
        localStorage.setItem(
          "permissionPath_jhk",
          JSON.stringify(this.pathList)
        );
        if (
          this.permissionPath.join() !==
          JSON.parse(JSON.stringify(this.pathList)).join()
        ) {
          // 不关闭页面重新刷新的情况
          // 解决同一路由vue缓存机制不刷新的情况
          this.$router.push({
            path: this.$route.path,
            query: { timetemp: Date.parse(new Date()) },
          });
        }
      });
    },

    routeLocal(list, parentPath) {
      list.map((item) => {
        const path = item.path.split("?")[0];
        if (path.indexOf("/") != -1) {
          this.pathList.push(parentPath + path);
        } else {
          this.pathList.push(parentPath + "/" + path);
        }
        if (item.children.length) {
          if (path.indexOf("/") != -1) {
            this.routeLocal(item.children, parentPath + path);
          } else {
            this.routeLocal(item.children, parentPath + "/" + path);
          }
        }
      });
    },

    toShop() {
      window.open(
        `https://mall.jd.com/index-${this.$store.getters.loginUserInfo.shopId}.html`,
        "_blank"
      );
    },
    handlePlatform() {
      var url = "http://yei8.cn/AXsH";
      window.open(url, "_blank");
    },

    toOldVersion() {
      // 返回旧版
      returnOldSystem().then((res) => {
        if (res.code == "1") {
          var url = res.data.url + "?" + "token=" + res.data.token;
          window.location = url;
        }
      });
    },
    async getBindList() {
      await getSellerInfo().then((resp) => {
        console.log(resp, 111);
        if (resp.data) {
          this.flag = true;
          this.editUserInfo(resp && resp.data);
          window.sessionStorage.setItem("loginUserInfo", JSON.stringify(resp && resp.data));
          this.venId = resp.data.venderId;
        }
      });
    },
    topTab(ind, item) {
      // console.log(ind,item, "1111111");
      this.topActive = ind;
      this.activeNavStyle = this.getNavStyle(ind);
      var path = item.path;

      if (item.children && item.children[0].path) {
        path = item.path + "/" + item.children[0].path;
      }

      if (
        item.children &&
        item.children[0].path &&
        item.children[0].children &&
        item.children[0].children[0].path
      ) {
        path =
          item.path +
          "/" +
          item.children[0].path +
          "/" +
          item.children[0].children[0].path;
      }

      // console.log("path==", path);
      this.$router.push({ path: path });
      this.bus.$emit("topActive", { index: ind, item: item });
      if (item.path == "/integralCenter") {
        this.loginEvent();
      }
    },
    //登录
    loginEvent() {
      let venderId = { venderId: this.venId };
    },

    toBindShop() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/account/store_binding",
        // query: { to: "/account/store_binding" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 跳转到充值页面
    toRecharge() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management" },
      });
      window.open(routeUrl.href, "_blank");
    },
    //去设置页面
    toSetting() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/account/account" },
      });
      window.open(routeUrl.href, "_blank");
    },
    switchStore() {
      this.accountSwitches = !this.accountSwitches;
    },
    //退出登录
    log_out() {
      logout().then((res) => {
        if (res.code == 1) {
          this.$message.success("退出成功");
          setTimeout(() => {
            location.href = res.message;
          }, 2000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    toggleSwitch(item) {
      if (!this.accountSwitches) {
        switchShop({ sellerNick: item.shopName }).then((res) => {
          if (res.code == "1") {
            // this.softwarename = item;
            this.getBindList();
            // 刷新下
            this.$router.push({
              path: "/refresh",
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    feedback() {
      this.$emit("openWindow", true);
    },
    getNavStyle(index) {
      if (this.$refs.mainHeader) {
        let childNodes = this.$refs.mainHeader.childNodes;
        let width = Number(childNodes[index] && childNodes[index].clientWidth);
        let left = 0;
        if (index > 0) {
          for (let i = 0; i < index; i++) {
            if (this.screenWidth < 1370) {
              left += childNodes[i].clientWidth + 5;
            } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
              left += childNodes[i].clientWidth + 25;
            } else {
              left += childNodes[i].clientWidth + 50;
            }
          }
        }
        return { width, left };
      }
    },

    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(
        DateOne.length,
        DateOne.lastIndexOf("-") + 1
      );
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(
        DateTwo.length,
        DateTwo.lastIndexOf("-") + 1
      );
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha =
        (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) -
          Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) /
        86400000;
      return Math.abs(cha);
    },

    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },

    toUserInform() {
      this.$emit("Fun_isShow_page");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .theme-picker {
  left: 5px;
  opacity: 0;
}
.rightContent {
  display: flex;
  align-items: center;
  float: right;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #333;
  height: 60px;
  line-height: 60px;
  text-align: center;
  .authorization {
    width: 60px;
    height: 28px;
    background: rgba(123, 97, 255, 0.1);
    border-radius: 8px;
    border: 1px solid #7b61ff;
    color: #7b61ff;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    // margin: 0 10px;
    border-radius: 50px;
    margin-left: 12px;
  }
  .head-name {
    .head-name-tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 106px;
    }
    // @media screen and (max-width: 1320px) {
    // @media screen and (max-width: 1780px) {
    //   display: none;
    // }
  }

  .message {
    min-width: 1362px;
    display: inline-block;
    position: relative;
    margin-right: 32px;
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEl {
      width: 229px;
      height: 117px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 72px;
          height: 26px;
          /*background: rgba(32, 98, 231, 1);*/
          /*box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);*/
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 26px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }
  .message:hover {
    .hoverEl {
      display: inline-block;
    }
  }
  .expireTime {
    display: inline-block;
    margin-right: 32px;
    position: relative;
    @media screen and (max-width: 1600px) {
      display: none;
    }
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEle {
      width: 229px;
      height: 130px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          background: rgba(32, 98, 231, 1);
          box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .time {
        color: rgba(153, 153, 153, 1);
        margin-top: 10px;
      }
    }
  }
  .expireTime:hover {
    .hoverEle {
      display: inline-block;
    }
  }
  .head {
    display: inline-block;
    width: auto;
    height: 48px;
    line-height: 40px;
    vertical-align: top;
    margin-right: 15px;
    position: relative;
    margin-top: 8px;
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    img {
      display: inline-block;
      vertical-align: middle;
      // background-color: #fff !important;
    }
    .hoverElement {
      width: 190px;
      height: 150px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
      position: absolute;
      top: 45px;
      right: -24px;
      display: none;
      border-radius: 5px;
      padding-top: 10px;
      line-height: normal;
      text-align: left;
      &_xito {
        display: block;
        padding: 0 10px 10px 10px;
        border-bottom: 1px solid #f0f0f0;
      }
      &_setting {
        padding: 15px 20px;
        &:hover {
          color: #7b61ff;
        }
      }
      .xiantiao {
        width: 100%;
        height: 1px;
        background: #f0f0f0;
        opacity: 1;
        margin: 12px 0;
      }
      .userInfo {
        .headImg {
          margin-top: 10px;
          width: 207px;
          height: 68px;
          border-radius: 24px;
          display: inline-block;
          img {
            width: 207px;
            height: 68px;
            border-radius: 4px;
          }
        }
        .shopName {
          width: 145px;
          font-size: 14px;
          // top: 10px;
          // left: -14px;
          position: relative;
          font-family: PingFangSC-Regular;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          display: inline-block;
          vertical-align: top;
          margin-left: 0px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          &:hover {
            color: #7b61ff;
          }
        }
        .vesion {
          position: relative;
          // left: 157px;
          // top: -8px;
          width: 54px;
          height: 18px;
          background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
          opacity: 1;
          border-radius: 12px;
          // width: 54px;
          padding: 2px;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #fff;
          display: inline-block;
          line-height: 15px;
          text-align: center;
          vertical-align: bottom;
        }
      }
      .callkf {
        cursor: pointer;
        height: 22px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        margin: 0px 0px 0 55px;
        width: 98px;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
      }
      .callkf:hover {
        color: #7b61ff;
      }
      .setting {
        cursor: pointer;
        height: 40px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        border-top: 1px solid #f0f0f0;
        top: 215px;
        left: 0px;
        width: 50%;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        padding-top: 18px;
        // border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
        &:hover {
          color: #7f85e9;
        }
      }
      .callkf1 {
        cursor: pointer;
        height: 40px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        border-top: 1px solid #f0f0f0;
        // border-left: 1px solid #f0f0f0;
        top: 215px;
        right: 0;
        padding-top: 18px;
        width: 50%;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        // border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
      }
      .callkf1:hover {
        color: #7b61ff;
      }
      .switch {
        height: 150px;
        // background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
        color: #333333;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        // height: 150px;
        overflow: auto;
        .switch-body {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-body1 {
          border-bottom: 1px solid #f0f0f0;
          padding-top: 4px;
          padding-bottom: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-content {
          display: flex;
          align-items: center;
        }
        img {
          width: 32px;
          color: #709fff;
        }
        .noimagesBox {
          width: 207px;
          // height: 100px;

          background: #fff;
          // opacity: 1;
          // border-radius: 4px;
        }
        .toBindShop {
          padding: 5px 18px;
          position: absolute;
          top: 253px;
          left: 72px;
          width: 110px;
          color: #7b61ff;
          height: 32px;
          background: #fff4f4;
          border: 1px solid #7b61ff;
          opacity: 1;
          border-radius: 4px;
          &:hover {
            color: #7b61ff;
            background-color: #ffe5e5;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
        .toggle {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #7b61ff;
          border: 1px solid #7b61ff;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #7b61ff;
            background-color: #ffe5e5;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
        .toggle1 {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #7f85e9;
          border: 1px solid #7f85e9;
          border-radius: 4px;
          background-color: #f7f8fe;
          &:hover {
            color: #7f85e9;
            background-color: #f2f3fd;
          }
          &:active {
            color: #7f85e9;
            border: 1px solid #7f85e9;
            background-color: #ecedfc;
          }
        }
      }
      .qiehuan {
        cursor: pointer;
        float: right;
        opacity: 1;
        position: relative;
        top: 0px;
        i {
          font-size: 14px;
        }
        .switch {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
        .accomplish {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
      }
      .qiehuan:hover {
        opacity: 0.7;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: #252c38;
        .button {
          width: 70px;
          height: 28px;
          // float: right;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          font-weight: 400;
          color: #7b61ff;
          border: 1px solid #7b61ff;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #7b61ff;
            background-color: #ffe5e5;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
      }
      .text1 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #252c38;
        margin-bottom: 4px;
        margin-top: 4px;
      }
      .num1 {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          font-weight: 400;
          cursor: pointer;
          color: #7b61ff;
          border: 1px solid #7b61ff;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #7b61ff;
            background-color: #ffe5e5;
          }
          &:active {
            color: #7b61ff;
            border: 1px solid #7b61ff;
            background-color: #fff4f4;
          }
        }
      }
      .time {
        color: #7f85e9;
        margin-top: 10px;
        font-size: 12px;
      }
    }
  }
  .head_showInfo {
    display: inline-block;
    cursor: pointer;
  }
  .head_showInfo:hover {
    .hoverElement {
      display: inline-block;
    }
  }
  .help {
    display: flex;
    align-items: center;
    height: 60px;
    width: 60px;
    line-height: 60px;
    margin-right: 30px;
    .edition {
      display: inline-block;
      width: 62px;
      height: 18px;
      color: #fff;
      text-align: center;
      background: url("../assets/images/edition_bg.png") no-repeat 100% center;
      span {
        display: inline-block;
        transform: scale(0.8);
      }
    }
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    vertical-align: top;
  }
  .changeSkin {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 20px;
    height: 60px;
    width: 32px;
  }
  .jiuban_button {
    width: 74px;
    height: 30px;
    background: #7b61ff;
    border-radius: 15px 2px 15px 2px;
    line-height: 30px;
    text-align: center;
    margin-right: 20px;
    color: #fff;
    margin-left: 12px;
  }
}

.top {
  display: flex;
  justify-content: center;
  position: absolute;
  top: -14px;
  left: 110px;
  img {
    width: 20px;
    height: 20px;
  }
}

.customerService {
  padding: 20px;
  .title {
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 900;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
  }
  .toService {
    margin-top: 13px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
    .phone {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(32, 98, 231, 1);
      line-height: 20px;
      img {
        width: 28px;
        height: 28px;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }

  .wechatService {
    margin-top: 12px;
    display: flex;
    padding: 0 10px;
    justify-content: space-between;
    .QRcode {
      width: 95px;
      height: 95px;
      background: rgba(216, 216, 216, 1);
      border: 1px solid rgba(151, 151, 151, 1);
    }
  }
}
.help {
  // margin-top: 10px;
  display: flex;
  // padding: 0 10px;
  justify-content: space-between;
  div {
    width: 96px;
    height: 28px;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(32, 98, 231, 1);
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
  .helpTitle {
    border: none;
    width: 85px;
    color: #fff;
    line-height: 20px;
    height: 20px;
    margin-top: 5px;
    img {
      width: 11px;
      height: 11px;
      margin-left: 3px;
    }
  }
}

.container {
  height: 60px;
  width: 100%;
  transition: all 0.5s;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 25;
  box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.05);
  .logo {
    box-sizing: border-box;
    width: 170px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    vertical-align: top;
    display: inline-block;
    height: 60px;
    line-height: 65px;
    @media screen and (min-width: 1500px) and (max-width: 1700px) {
      line-height: 68px;
    }
    @media screen and (min-width: 1400px) and (max-width: 1499px) {
      line-height: 69px;
    }
    @media screen and (max-width: 1399px) {
      line-height: 70px;
    }
    padding: 5px 0;
    text-align: center;
    img {
      display: inline-block;
      margin-top: -22px;
      // width: 140px;
      @media screen and (max-width: 1366px) {
        margin-top: -24px;
      }
      // height: 40px;
      vertical-align: middle;
    }
    img:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
    }
  }
  .module {
    display: inline-block;
    width: calc(100% - 531px);
    // margin-left: 20px;
    // @media screen and (min-width: 1440px) {
    //   margin-left: 0;
    // }
    .nav {
      width: 100%;
      display: flex;
      justify-content: end;
      margin-right: 10px;
      display: inline-flex;
      position: relative;
      height: 60px;
      line-height: 72px;
      overflow: hidden;
      .nav-item {
        position: relative;
        padding: 0 10px;
        margin-right: 15px;
        bottom: 5px;
        color: #d5d6de;
        font-size: 16px;
        cursor: pointer;
        &:hover::before {
          bottom: -5px;
          opacity: 1;
          // @media screen and (max-width: 1300px) {
          //   bottom: -2px;
          // }
        }
        &::before {
          content: "";
          position: absolute;
          bottom: -11px;
          left: 0;
          width: 100%;
          height: 4px;
          // background-color: #555a7a;
          border-radius: 8px 8px 0 0;
          // opacity: 0;
          // transition: 0.3s;
        }
      }
      .nav-underline {
        position: absolute;
        bottom: 0;
        margin-left: 2px;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background-color: #7b61ff;
        transition: all 0.4s ease-in-out;
      }
      .navActive {
        color: #fff;
      }
      // .nav-item.navActive {
      //   // &::before {
      //   //   bottom: 0;
      //   //   opacity: 1;
      //   //   background-color: #7B61FF;
      //   // }
      // }
    }
    .item {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #d5d6de;
      line-height: 30px;
      text-align: center;
      margin-left: 64px;
      cursor: pointer;
      height: 30px;
      &:hover {
        color: white;
        &::before {
          content: "";
          width: 150%;
          background-color: #555a7a;
          height: 4px;
          font-size: 16px;
          position: absolute;
          bottom: -11px;
          border-radius: 4px;
          left: -50%;
          transform: translateX(18%);
        }
      }
    }
    .active {
      width: 150%;
      background-color: #7b61ff;
      height: 4px;
      font-size: 16px;
      position: absolute;
      bottom: -11px;
      border-radius: 4px;
      left: -50%;
      transform: translateX(18%);
    }
    .item.tabActive {
      color: #fff !important;
    }
  }
  .white-bar {
    width: 90px;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: 30px;
  }
}

.headerContactBox {
  padding: 20px 10px !important;
  .info {
    padding: 0 9px 17px 9px;
    border-bottom: 1px solid #f3f3f3;
    color: #333;
    font-size: 14px;
    .labelTxt {
      display: inline-block;
      width: 65px;
    }
    .btnContact {
      position: relative;
      margin-left: 6px;
      padding: 0 15px;
      line-height: 20px;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      background: #fff;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      transition: all 0.2s linear;
      outline: none;
      .hoverIcon {
        position: absolute;
        left: 15px;
        top: 3px;
        opacity: 0;
      }
      &:hover {
        color: #5882fb;
        border: 1px solid #5882fb;
        background: rgba(88, 130, 251, 0.1);
        .icon {
          opacity: 0;
        }
        .hoverIcon {
          width: 13px;
          height: 13px;
          opacity: 1;
        }
      }
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .btn {
      width: 110px;
      height: 28px;
      line-height: 26px;
      border: 1px solid #ccc;
      color: #999;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.2s linear;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #5882fb;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(88, 130, 251, 1);
      }
      &:active {
        color: #3d6fff;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(61, 111, 255, 1);
      }
    }
  }
}
@media screen and (min-width: 1369px) and (max-width: 1572px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 25px;
        }
      }
    }
  }
}
@media screen and (max-width: 1369px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 5px;
        }
      }
    }
  }
}

.shop_div {
  width: 100%;
  display: flex;
  height: 32px;
  align-items: center;
  justify-content: space-between;
}
</style>
<style lang="scss">
.dialongTransition12 {
  .el-dialog {
    background: transparent;
    box-shadow: none !important;
    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }
}
</style>
